/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetSecretGroupsResponseItems,
    GetSecretGroupsResponseItemsFromJSON,
    GetSecretGroupsResponseItemsFromJSONTyped,
    GetSecretGroupsResponseItemsToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetSecretGroupsResponse
 */
export interface GetSecretGroupsResponse {
    /**
     * 
     * @type {Array<GetSecretGroupsResponseItems>}
     * @memberof GetSecretGroupsResponse
     */
    items: Array<GetSecretGroupsResponseItems>;
}

export function GetSecretGroupsResponseFromJSON(json: any): GetSecretGroupsResponse {
    return GetSecretGroupsResponseFromJSONTyped(json, false);
}

export function GetSecretGroupsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSecretGroupsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(GetSecretGroupsResponseItemsFromJSON)),
    };
}

export function GetSecretGroupsResponseToJSON(value?: GetSecretGroupsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(GetSecretGroupsResponseItemsToJSON)),
    };
}


